import { render, staticRenderFns } from "./EldCert.vue?vue&type=template&id=708acd21&"
import script from "./EldCert.vue?vue&type=script&lang=ts&"
export * from "./EldCert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports